import React from 'react';
import { Loader } from '@groupelacentrale/contact-storybook';

export const LoadingPreview: React.FC = () => {
  return (
    <div className="photo-preview--loading">
      <Loader />
    </div>
  );
};
